import { TaskSchedulesGridView } from '~/components/system/task-schedules';
import { PageContainer } from '~/components/page-container';

export function TaskSchedules() {
	return (
		<PageContainer>
			<TaskSchedulesGridView />
		</PageContainer>
	);
}
